<template>
  <div>
    <TitledProgressStepper
      :steps="steps"
      class="mb-lg"
    />

    <DocumentsPage />
  </div>
</template>

<script setup>
// @ts-check
import { onBeforeMount } from 'vue';

import { useEnvelopesProgress } from '@/composables/envelopes';

import { TitledProgressStepper } from '@/components/library/progressSteppers/TitledProgressStepper';
import DocumentsPage from '@/components/pages/envelopes/DocumentsPage';

const { steps } = useEnvelopesProgress();

// make sure that we don't have previous data hanging around
onBeforeMount(() => {
  // reset();
});
</script>
